jQuery(document).ready(function(){
  jQuery('.mad-scroll-to-top').show();

  jQuery(window).scroll(function(){
      const scrollTop = jQuery(this).scrollTop();
      const documentHeight = jQuery(document).height();
      const windowHeight = jQuery(this).height();
      
      if (scrollTop > 800 && documentHeight - scrollTop - windowHeight > 100) {
          jQuery('.mad-scroll-to-top').addClass('active');
      } else {
          jQuery('.mad-scroll-to-top').removeClass('active');
      }
  });

  jQuery('.mad-scroll-to-top').click(function(){
      jQuery('html, body').animate({ scrollTop: 0 }, 400);
      return false;
  });
});